import { ModelBase } from '../../core/model/model-base';

export class BuildingSpaceType extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.id = dataContext.id;
      this.bsabCode = dataContext.bsabCode;
      this.caption = dataContext.caption;
    }
  }

  bsabCode: string;
  caption: string;

  toString() {
    if (!this.caption) return '';

    if (!this.bsabCode) return this.caption;

    return `${this.caption} (${this.bsabCode})`;
  }
}
